import { render, staticRenderFns } from "./registHasOrgs.vue?vue&type=template&id=5a9e9774&scoped=true&"
import script from "./registHasOrgs.vue?vue&type=script&lang=js&"
export * from "./registHasOrgs.vue?vue&type=script&lang=js&"
import style0 from "./registHasOrgs.vue?vue&type=style&index=0&id=5a9e9774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e9774",
  null
  
)

export default component.exports